import React from "react";
import "./Footer.css";

const Footer = () => {
  const handlePrivacyClick = () => {
    alert("Privacy Policy page would open here.");
  };

  const handleCookiePrefs = () => {
    alert("Cookie preferences would open here.");
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* <div className="footer-logo">
            <span className="logo-text">inTax</span>
            <p className="footer-tagline">accounting for a successful future</p>
          </div> */}

          <div className="footer-links">
            <div className="footer-column">
              <h4>Services</h4>
              <a href="#services">Taxation Services</a>
              <a href="#services">Company Formation</a>
              <a href="#services">Accounting Services</a>
              <a href="#services">VAT Registration</a>
              <a href="#services">Payroll Management</a>
            </div>

            <div className="footer-column">
              <h4>Quick Links</h4>
              <a href="#home">Home</a>
              <a href="#services">Services</a>
              <a href="#about-us">About Us</a>
              <a href="#packages">Packages</a>
              {/* <a href="#why-us">Why We're Best</a> */}
              {/* <a href="#team">Our Team</a> */}
            </div>

            <div className="footer-column">
              <h4>Contact</h4>
              <a href="mailto:info@hnu.ie">info@hnu.ie</a>
              {/* <a href="+353894570085">+353894570085</a>
              <a href="+353834722774">+353834722774</a> */}

              <p>Santry, Dublin 9, Ireland.</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy;HNU. All rights reserved.
            {/* <button className="privacy-link" onClick={handlePrivacyClick}>
              Privacy Policy
            </button>{" "}
            |
            <button className="cookie-prefs" onClick={handleCookiePrefs}>
              Cookie Preferences
            </button> */}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
